var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        title: _vm.$t("basicData.CustomVersion"),
        visible: _vm.dialogVisible,
        width: "900px",
        "close-on-click-modal": false,
        "close-on-press-escape": false,
        "append-to-body": true,
        "show-close": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
      },
    },
    [
      _c(
        "div",
        { staticClass: "filter-section" },
        [
          _c(
            "el-form",
            {
              attrs: {
                model: _vm.filterForm,
                "label-position": "top",
                size: "small",
              },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 10 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("basicData.siteName") } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              placeholder: _vm.$t(
                                "basicData.DataDerivedNotModifiable"
                              ),
                            },
                            model: {
                              value: _vm.filterForm.siteName,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "siteName", $$v)
                              },
                              expression: "filterForm.siteName",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "basicData.QuotationMatchingDimensions"
                            ),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              placeholder: _vm.$t(
                                "basicData.DataDerivedNotModifiable"
                              ),
                            },
                            model: {
                              value: _vm.filterForm.matchDimension,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "matchDimension", $$v)
                              },
                              expression: "filterForm.matchDimension",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("placeOrder.goodType") } },
                        [
                          _c("el-input", {
                            attrs: {
                              disabled: "",
                              placeholder: _vm.$t(
                                "basicData.DataDerivedNotModifiable"
                              ),
                            },
                            model: {
                              value: _vm.filterForm.cargoType,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "cargoType", $$v)
                              },
                              expression: "filterForm.cargoType",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 16 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "basicData.QuotationVersionSelection"
                            ),
                          },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              placeholder: _vm.$t(
                                "basicData.PleaseEnterQuotationPlanNameForFuzzySearch"
                              ),
                              clearable: "",
                            },
                            model: {
                              value: _vm.filterForm.searchKeyword,
                              callback: function ($$v) {
                                _vm.$set(_vm.filterForm, "searchKeyword", $$v)
                              },
                              expression: "filterForm.searchKeyword",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c(
                        "el-form-item",
                        { staticClass: "searchBtn" },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "small" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v(_vm._s(_vm.$t("basicData.reset")))]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-section" },
        [
          _c(
            "el-table",
            {
              staticStyle: { width: "100%" },
              attrs: { data: _vm.filteredTableData, border: "", size: "small" },
            },
            [
              _c("el-table-column", {
                attrs: { width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-radio", {
                          attrs: { label: scope.row.id },
                          on: {
                            change: function ($event) {
                              return _vm.handleSelectChange(scope.row)
                            },
                          },
                          model: {
                            value: _vm.selectedVersion,
                            callback: function ($$v) {
                              _vm.selectedVersion = $$v
                            },
                            expression: "selectedVersion",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.TheNameOfTheQuoteProposal"),
                  prop: "name",
                  "min-width": "200",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: _vm.$t("basicData.TheValidityPeriodBegins"),
                  prop: "startOfValidityPeriod",
                  width: "180",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c(
            "el-button",
            { attrs: { size: "small" }, on: { click: _vm.handleCancel } },
            [_vm._v(_vm._s(_vm.$t("basicData.Cancel")))]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary", size: "small" },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(_vm._s(_vm.$t("basicData.determine")))]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }